export default "__VITE_ASSET__Cwl1ZzuH__"